<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>
    <!--====== PRELOADER PART START ======-->

    <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>
        <div class="layer layer-three"><span class="overlay"></span></div>
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->
<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->
    <!--====== OFFCANVAS MENU PART ENDS ======-->

    <!--====== APPIE HEADER PART START ======-->

<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->


    <section class="appie-testimonial-2-area " id="testimonial">
      <div class="container maincard mt-4 mb-4"  v-if="!showloading">
        <div class="row ">
          <div class="col-md-4  mt-4 ">
            <img src="https://d314xssrurywid.cloudfront.net/bTe00Q6l1UeDW2VvJzWcPVD7DQBQabO7mE3Hft5U.webp">
          </div>
          <div class="col-md-8 ">
            <div class="col-lg-12 ">
              <h4  v-if="list.length > 0 " style="font-weight: 800;text-align: center;" class="mt-3">{{ title }}</h4>
              <br>
              <div class="row" >
                <div v-if="list.length > 0"  class="row">
                  <div>
                    <button class="homebtn"  @click="homeredirect(homebuttonurl)"  style="float:right">
                      {{ homebutton}}
                    </button>
                  </div>

                  <!--              <div v-if="list.length > 0">-->
                  <div class="col-12 col-sm-12 col-lg-6 mb-20 temp_10_space mt-1" v-for="(ListData,index) in list" :key="index">
                    <div class="card" style="width: 100%">

                      <div class="card-body d-flex align-items-center p-2">



                        <div class="ms-3">
                          <p style="font-weight: bold;">{{ cleanName(ListData['company-name']) }}</p>
                          <p>{{ ListData.area }}</p>

                        </div>


                      </div>

                    </div>
                  </div>
                </div>
                <div v-else style="text-align: center;color: red;width: 50%;margin: auto" class="card p-2">
                  <b>There Is Currently No Nearby Company</b>
                  <br>
                  <div style="text-align: center">
                    <button class="homebtn"  @click="homeredirect(homebuttonurl)" >
                      {{ homebutton}}
                    </button>
                  </div>
                </div>
                <span v-if="loading" style="text-align: center"> loading...</span>

              </div>

            </div>
          </div>

        </div>
      </div>

      <div>
        <b-modal id="modal-center1" centered title="BootstrapVue">
          <div class="row">
            <!-- First Card Row -->
            <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
              <span v-html="stripTags(customerCareData.label)"></span>


              <div class="card" >
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-2 col-lg-2 col-md-2">
                      <div class="d-flex justify-content-center align-items-center h-100">
                        <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="col-8 col-lg-8 col-md-8">
                      <div class="d-flex flex-column justify-content-center h-100">
                        <span>{{ customerCareData.name }}</span>
                        <span v-html="customerCareData.description"></span>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </section>




    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import LoaderAppie from '../LoaderAppie.vue'
import CryptoJS from "crypto-js";
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import SidebarHomeOne from '../HomePage/SidebarHomeOne.vue'

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";


export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    LoaderAppie,

    // SidebarHomeOne,
  },
  data() {
    return {
      showloading:false,
      isFetchingData: false,
      lastId:0,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      textSize: '',
      countView: [],
      list: [],
      homebutton:'',
      homebuttonurl:'',
      ListTitleData: [],
      ListButtonData: [],
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        // {
        //   // name:'contact',
        //   name: 'Home',
        //   path: '/home-page'
        // },
        // {
        //   name: 'Profile',
        //   childrens: [
        //     {
        //       // name:'Home 1',
        //       name: 'Update KYC',
        //       path: '/'
        //     },
        //     {
        //       // name:'Home 2',
        //       name: 'Update Profile',
        //       path: '/home-two'
        //     },
        //     {
        //       // name:'Home 3',
        //       name: 'View Profile',
        //       path: '/home-three'
        //     },
        //     {
        //       // name:'Home 4',
        //       name: 'Viewed Profiles',
        //       path: '/home-four'
        //     },
        //     {
        //       // name:'Home 5',
        //       name: 'Change Mobile Number',
        //       path: '/home-five'
        //     },
        //     // {
        //     //   name:'Home 6',
        //     //   path:'/home-six'
        //     // },
        //     // {
        //     //   name:'Home 7',
        //     //   path:'/home-seven'
        //     // },
        //     // {
        //     //   name:'Home 8',
        //     //   path:'/home-eight'
        //     // },
        //   ],
        // },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        // {
        //   // name:'contact',
        //   name: 'Customer Care',
        //   path: '/contact'
        // },
        // {
        //   // name:'contact',
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },


  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {

    if (this.$route.query.page) {
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);
      this.modifiedString = decryptedString;
      try {

        const PaymentHistoryData = await callAxiosWithConfig(this.modifiedString, {'lastId': 0, 'listSize': 0}, 'post');
        // const PaymentHistoryData = await callAxiosWithConfig('https://jobspro.nithrajobs.com/api/' + this.modifiedString, {'lastId': 0,'listSize':0}, 'post');
        // console.log('PaymentHistoryData', PaymentHistoryData);
        // console.log(PaymentHistoryData.title);

        this.title = PaymentHistoryData.title;
        this.countView = PaymentHistoryData.countView;
        this.list = PaymentHistoryData.list;
        this.homebutton = PaymentHistoryData.button;
        this.homebuttonurl = PaymentHistoryData.url;
        localStorage.setItem('homeurl', this.homebuttonurl);
        this.showloading=false;
        if(PaymentHistoryData.status == true){
          if (PaymentHistoryData.list.length > 0) {
            this.lastId = PaymentHistoryData.list[PaymentHistoryData.list.length - 1].id;
          }
        }
        // this.template = otpdata.template;
        // console.log(this.template)
        // const inputString = otpdata;
        // this.$emit("tempData", this.title);

        // this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
        // this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
        // this.customerCare = JSON.parse(localStorage.getItem("customerCare"));
        //
        // console.log(this.SideMenu)
        // this.$emit("tempData", this.SideMenu);
        // this.$emit("title", this.titleWord);
        // this.$emit("customerCare", this.customerCare);



      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Handle 401 status silently
          // For example, do nothing or log a message without displaying it
        } else {
          // Handle other errors by displaying them
          console.error('Error in Axios request:', error);
        }
      }
      // this.modifiedString='https://jobspro.nithrajobs.com/api/home/nearByCompanies';
      // alert(this.modifiedString);
      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    }

    // this.encryptedParam = this.$route.query.page;
    // // alert(this.$route.query.id);
    // // alert(this.$route.query.page);
    // this.decryptedValue = this.Decrypt(this.encryptedParam);
    // this.modifiedString = this.decryptedValue.replace(/-/g, '/');
    // console.log(this.modifiedString)

    window.addEventListener('scroll', this.handleScroll);

  },

  methods: {
    async handleScroll() {
      if (this.isFetchingData) {
        // alert(this.isFetchingData)
        return;
      }
      // Check if the user has scrolled to the bottom of the page
      const distanceToBottom = document.documentElement.scrollHeight - (window.innerHeight + window.scrollY);
      if (distanceToBottom < 100) {
        this.isFetchingData = true;
        this.loading=true;
        const loadmoreData = await callAxiosWithConfig(this.modifiedString, {'lastId': this.lastId, 'listSize': 0}, 'post');
        if(loadmoreData.status == true){
          // console.log(loadmoreData)
          if (loadmoreData.list.length > 0){
            this.list = [...this.list, ...loadmoreData.list];
            // Update the lastId with the id of the last element in the new data
            this.lastId = loadmoreData.list[loadmoreData.list.length - 1].id;
            this.isFetchingData = false;
            this.loading=false;

          }
          else{
            this.loading=false;
          }


        }
        else{
          this.loading=false;
        }

      }
    },

    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },


    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },

    cleanName(name) {
      let cleanname=name.replace(/\+/g, ' ');
      return decodeURIComponent(cleanname);
    },

    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },
    async homeredirect(url) {

      const encryptedString = this.encryptUrl(url);

      // Redirect to the company-register page with the encrypted URL

      await this.$router.push(`/home-page?page=${encodeURIComponent(encryptedString)}`);
    },

    async GetPlan(activity, url) {
      // alert(activity)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;

      if (lastPart === 'Employer_Common_Webview_Activity') {

        window.location.href = this.urlData
      }
    },

    async OpenEmployeeView(activity, url) {
      // alert(activity)
      // console.log(activity)
      // console.log(url)
      // alert(url)

      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      this.urlData = url;

      if (lastPart === 'Employer_Dynamic_Job_View') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/post-view?page=${encodeURIComponent(encryptedString)}`);
      } else if (lastPart === 'Employer_Dynamic_Home_Activity') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/home-page?page=${encodeURIComponent(encryptedString)}`);
        localStorage.setItem('homeurl', url)
      } else if (lastPart === 'Employer_Common_Webview_Activity') {
        // console.log('xfgs')
        window.location.href = this.urlData;
      }
    },


    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },
  }

}
</script>

<style>

.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}

.appie-features-box-item.item-2:hover {
  border-color: unset;
}
.homebtn{

  width: 100px;
  margin: 0px 2px;
  border-radius: 10px;
  padding: 5px;
  border: unset;
  background: #4D5BE1;
  text-align: center;
  color: white;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }
}
.maincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;
  width: 100%;
}

@media (min-width: 768px) {
  .maincard {
    width: 90% !important;
    margin: auto;
  }
}

</style>
